import styled from "styled-components";
export const Icon = styled.i.attrs({
    'aria-hidden': true
}) `
    display: inline-block;
    width: ${({ size }) => size ? `${size}px` : '24px'};
    height: ${({ size }) => size ? `${size}px` : '24px'};

    vertical-align: middle;

    background-image: url(/static/website/images_apps/icons/${({ name }) => name}.svg);
    background-position: center;
    background-size: contain;
    background-repeat: no-repeat;
`;
